import { GENERIC_VIEW_SEED_IDS } from '@featit/shared/view-engine/generic-view-seed-headings';
import { isViewUrlParam, NEW_VIEW_PARAM, SELECTED_ITEM_PARAM } from './viewUrlState';

/**
 * F-0549 VO-17 (`docs/concept-views-overview.md`, *Address*): what the bare Views address opens.
 *
 * - `?new=1` is the editor for a new view, on the overview's own address (VO-11).
 * - A query holding a view's own state (a filter, a control, the sort, a drill: `isViewUrlParam`) or
 *   an open item (`?item=`) was a link to a filtered Work items, from before the overview was the
 *   bare address. It goes to Work items with the same query, so it opens what it opened before.
 * - Anything else is the overview.
 */
export type ViewsBareAddressTargetType =
  | { kind: 'editor' }
  | { kind: 'work-items'; to: string }
  | { kind: 'overview' };

/** The URL id of Work items, the view an old bare-address link meant. */
export const WORK_ITEMS_VIEW_URL_ID = GENERIC_VIEW_SEED_IDS.WORK_ITEMS;

/** `…/views` → `…/views/work-items`, whatever the scope's own base is. */
export function workItemsViewPath(viewsBase: string): string {
  return `${viewsBase.replace(/\/+$/, '')}/${WORK_ITEMS_VIEW_URL_ID}`;
}

export function viewsBareAddressTarget(
  pathname: string,
  search: string,
): ViewsBareAddressTargetType {
  const params = new URLSearchParams(search);
  if (params.get(NEW_VIEW_PARAM) === '1') return { kind: 'editor' };
  const carriesView = [...params.keys()].some(
    (key) => key === SELECTED_ITEM_PARAM || isViewUrlParam(key),
  );
  if (!carriesView) return { kind: 'overview' };
  const query = params.toString();
  return { kind: 'work-items', to: `${workItemsViewPath(pathname)}${query ? `?${query}` : ''}` };
}
